'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQeId = exports.getListItems = exports.getBackground = exports.getHeader = exports.getSecondaryHeadline = exports.getContent = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMarketingBanner = (0, _reselect.createSelector)([_common.getCardData, function (state) {
  return (0, _lodash2.default)(state.intlPage, 'page');
}], function (card, page) {
  return (0, _lodash2.default)(card, 'marketingBanner') || (0, _lodash2.default)(page, 'marketingBanner') || {};
});

var getContent = exports.getContent = (0, _reselect.createSelector)(getMarketingBanner, function (marketingBanner) {
  return marketingBanner.content || [];
});

var getSecondaryHeadline = exports.getSecondaryHeadline = (0, _reselect.createSelector)(getMarketingBanner, function (marketingBanner) {
  return ((0, _lodash2.default)(marketingBanner, 'desc') || []).map(function (d) {
    return d.text;
  }).join('');
});

var getHeader = exports.getHeader = (0, _reselect.createSelector)(getMarketingBanner, function (marketingBanner) {
  return (0, _lodash2.default)(marketingBanner, 'header') || '';
});

var getBackground = exports.getBackground = (0, _reselect.createSelector)(getMarketingBanner, function (marketingBanner) {
  return ((0, _lodash2.default)(marketingBanner, 'assets') || []).filter(function (a) {
    return a.type === 'BACKGROUND';
  }).map(function (a) {
    return { img: a.url };
  }).slice(-1).pop() || {};
});

var getListItems = exports.getListItems = (0, _reselect.createSelector)(getMarketingBanner, function (marketingBanner) {
  return (((0, _lodash2.default)(marketingBanner, 'desc') || []).find(function (item) {
    return item.type === 'LIST';
  }) || {}).content || [];
});

var getQeId = exports.getQeId = (0, _reselect.createSelector)(getMarketingBanner, function (marketingBanner) {
  return marketingBanner.qeId;
});